var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-image-header",
      style: "background-image: url('" + _vm.src + "')"
    },
    [
      _c("div", { staticClass: "o-width-limiter" }, [
        _vm.overlayimage
          ? _c("div", { staticClass: "c-image-header__overlayimage-wrapper" }, [
              _c("div", { staticClass: "c-image-header__overlayimage" }, [
                _c("img", {
                  staticClass: "c-image-header__roof",
                  attrs: {
                    src: _vm.overlayimage,
                    alt: "",
                    "aria-hidden": "true"
                  }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasContent
          ? _c("div", { staticClass: "c-image-header__content-wrapper" }, [
              _c("div", { staticClass: "c-image-header__content" }, [
                _c("img", {
                  staticClass: "c-image-header__roof",
                  attrs: {
                    src: "/gui/images/roof-white-total.svg",
                    alt: "",
                    "aria-hidden": "true"
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "c-image-header__text" }, [
                  _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.text) + "\n\t\t\t\t")
                ])
              ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }